export const TRANSCRIPT_MAX_CHARS = 50_000;
export const FORM_FILL_DEMO_INPUT_HEIGHT_CLASS = 'h-52';

export const AUDIO_MAX_BYTES = 10 * 1024 * 1024;
export const AUDIO_ALLOWED_MIME = new Set([
  'audio/mpeg',
  'audio/mp3',
  'audio/wav',
  'audio/wave',
  'audio/x-wav',
  'audio/mp4',
  'audio/m4a',
  'audio/x-m4a',
  'audio/webm',
  'audio/ogg',
]);
export const AUDIO_ACCEPT = '.mp3,.wav,.m4a,.webm,.ogg,audio/*';

export const DOCUMENT_MAX_BYTES = 10 * 1024 * 1024;
export const DOCUMENT_MAX_FILES = 1;
export const DOCUMENT_ALLOWED_MIME = new Set([
  'application/pdf',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/msword',
]);
export const DOCUMENT_ACCEPT = '.pdf,.doc,.docx';

export const isValidAudioFile = (file: File): boolean => {
  const mime = (file.type || '').toLowerCase();
  return AUDIO_ALLOWED_MIME.has(mime) && file.size <= AUDIO_MAX_BYTES;
};

export const areValidDocumentFiles = (files: File[]): boolean => {
  if (files.length === 0 || files.length > DOCUMENT_MAX_FILES) return false;
  return files.every(
    (file) =>
      DOCUMENT_ALLOWED_MIME.has((file.type || '').toLowerCase()) &&
      file.size <= DOCUMENT_MAX_BYTES
  );
};
